module.exports = function(app) {
	'use strict'
	app.directive('searchAllPostSortableDir',searchAllPostSortableDir);
	searchAllPostSortableDir.$inject=['$window','$timeout','reqursiveService','keyPress','getDataService','$rootScope','refreshtokenService','serverError','alertService', 'offlineError'];
	function searchAllPostSortableDir($window,$timeout,reqursiveService,keyPress,getDataService,$rootScope,refreshtokenService,serverError,alertService, offlineError) {
		return {
			restrict: 'E',
            scope:{
                parentObj:"=",
                sortableDataName:'=',
                searchTags:'=',
                searchCategories:'='
            },
            replace:true,
			template: require('./partial/searchAllPostSortable.html'),
			link: function(scope, ele, $attrs, ctrl) {
                scope.windowInnerWdth = window.innerWidth;
				scope.searchData = '';
                scope.searchTag = '';
                var title = '';
                var id = null;
                var size = 14;
                var from = 0;
                var tags = {
                    id:'',
                    name:''
                };
                var category = '';
                scope.allPosts = [];
                scope.removeTagShow = false;
                scope.removeTitleShow = false;
                scope.selectedCategory = {value:'all'};
                scope.loadMoreShow = false;
                scope.sortableOptions = {
                    connectWith: ".sortable-container",
                    start: function(e, ui) {
                        scope.modelClone = null;
                        scope.sourceModelClone = ui.item.sortable.sourceModel.slice();
                        scope.modelClone = angular.copy(ui.item.sortable.model)
                    },
                    stop: function(e, ui) {
                        // if the element is removed from the first container
                        if (
                          jQuery(e.target).hasClass("sortableFrom") &&
                          ui.item.sortable.droptarget &&
                          e.target != ui.item.sortable.droptarget[0]
                        ) {
                          ui.item.sortable.sourceModel.length = 0;
                          // clone the original model to restore the removed item
                          Array.prototype.push.apply(
                            ui.item.sortable.sourceModel,
                            scope.sourceModelClone
                          );
                          scope.sourceModelClone = null;
                        }
                    },
                    update: function(e, ui) {
                        if (jQuery(e.target).hasClass("sortableFrom") && ui.item.sortable.droptarget && e.target != ui.item.sortable.droptarget[0]) {
                            if(!scope.modelClone) return
                            if(scope.sortableDataName=='prFocusNews' || scope.sortableDataName=='focusData') {
                                parentLoop:
                                for(var prItem in scope.parentObj.prFocusNews) {
                                    for(var j = 0; j<scope.parentObj.prFocusNews[prItem].length;j++) {
                                        if(scope.modelClone.id == scope.parentObj.prFocusNews[prItem][j].document_id && scope.parentObj.prFocusNews[prItem][j].type =='post') {
                                            ui.item.sortable.cancel();
                                            alertService('danger', 'Opps! ', 'Post alredy exist in PR focus news!');
                                            break parentLoop
                                        }
                                    }
                                }
                                for(var i=0; i<scope.parentObj.focusData.length;i++) {
                                    if(scope.modelClone.id == scope.parentObj.focusData[i].document_id && scope.parentObj.focusData[i].type =='post') {
                                        ui.item.sortable.cancel();
                                        alertService('danger', 'Opps! ', 'Post alredy exist in focus news!');
                                        break
                                    }
                                }
                            } else {
                                for(var i = 0; i<scope.parentObj[scope.sortableDataName].length;i++) {
                                    if(scope.modelClone.id == scope.parentObj[scope.sortableDataName][i].id) {
                                        ui.item.sortable.cancel();
                                        alertService('danger', 'Opps! ', 'Post alredy exist!');
                                        break
                                    }
                                    
                                }
                            }
                        }
                        scope.modelClone = null;
                    }
                }
                scope.searchPress = function(evt) {
                    keyPress(evt);
                }
                scope.$on('recommended-news-select-tag', function(event,data) {
                    tags.id= data.selectedTagObj.tagId,
                    tags.name= data.selectedTagObj.tagName
                    scope.removeTagShow = true;
                    getPosts()
                });
                scope.searchTagChange = function() {
                    if(scope.searchTag.length == 0) {
                        tags.id = '';
                        tags.name = '';
                        scope.removeTagShow = false;
                        getPosts()
                    }
                }
                function getAllDescendantsCategory(children) {
                    for(var i = 0;i<children.length;i++) {
                        if(!category) {
                            category +=children[i]._id
                        }else {
                            category += ',' + children[i]._id
                        }
                        if(children[i].children && children[i].children.length>0) {
                            getAllDescendantsCategory(children[i].children)
                        }
                    }

                }
                scope.switchCategories = function() {
                    category = '';
                    if(scope.selectedCategory.value == 'all') {
                        category = '';
                    } else {
                        for(var i = 0; i<scope.categoriesTreeInput.length;i++) {
                            if(scope.selectedCategory.value == scope.categoriesTreeInput[i]._id) {
                                if(scope.categoriesTreeInput[i].children && scope.categoriesTreeInput[i].children.length>0) {
                                    getAllDescendantsCategory(scope.categoriesTreeInput[i].children)
                                } else {
                                category = scope.categoriesTreeInput[i]._id
                                }
                                break
                            }
                        }
                    }
                    scope.searchTag = tags.name;
                    getPosts()
                }
                var categoryTreeFunction= function() {
                    scope.categoriesTreeInput = reqursiveService.getReqursiveArray(scope.categories);
                    scope.categoriesTreeSelect = angular.copy(scope.categoriesTreeInput);
                    for(var i=0; i< scope.categoriesTreeSelect.length; i++) {
                      if(scope.parentObj.category == scope.categoriesTreeSelect[i]._id && scope.categoriesTreeSelect[i].visible) {
                        scope.selectedCategory = {value:scope.parentObj.category};
                        scope.switchCategories()
                      }
                      var n = (scope.categoriesTreeSelect[i].ancestors.length)*2;
                      var empty = "\u00A0";
                      for(var j=0;j<n;j++) {
                        scope.categoriesTreeSelect[i].name = empty+scope.categoriesTreeSelect[i].name;
                      }
                    }
                    if(scope.selectedCategory.value == 'all') {
                      getPosts();
                    }
                }
                scope.addToSortable = function(post) {
                    for(var i=0; i<scope.parentObj[scope.sortableDataName].length;i++) {
                      if(scope.sortableDataName=='focusData') {
                            if(post.id == scope.parentObj[scope.sortableDataName][i].document_id && scope.parentObj[scope.sortableDataName][i].type=='post') {
                                alertService('danger', 'Opps! ', 'Post alredy exist!');
                                return
                            }
                        } else {
                            if(post.id == scope.parentObj[scope.sortableDataName][i].id) {
                                alertService('danger', 'Opps! ', 'Post alredy exist!');
                                return
                            }
                        }
                    }
                    scope.parentObj[scope.sortableDataName].push(post)
                }
                if(scope.parentObj.categories && scope.parentObj.categories.length>0) {
                    scope.categories = scope.parentObj.categories
                    categoryTreeFunction()
                } else {
                    var getCategoriesFunction = function() {
                        getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(dataCategory){
                          scope.categories = dataCategory.categories;
                          categoryTreeFunction() 
                        }, function(error){
                          if(!window.navigator.onLine) {
                            offlineError()
                            return
                          }
                          if(error.status ==401) {
                            var promise = refreshtokenService.getAccessToken();
                            promise.then(
                                function(answer) {
                                  if(answer==200) {
                                    getCategoriesFunction();
                                  }
                                // do something
                              },
                              function(error) {
                                // report something
                              },
                              function(progress) {
                               // report progress
                            });
                          }
                        });
                    } 
                    getCategoriesFunction();
                      
                }
        
                scope.loadMore = function() {
                    from = from + size;
                    $timeout(function() {
                      getPosts('loadMore');
                    },0)
                }
                var timer;
                function debounce(func, timeout){
                    clearTimeout(timer);
                    timer = $timeout(function() { 
                      func(); 
                    }, timeout);
                }
                scope.searchTitleOrIdChange = function() {
                    if(scope.searchTitle.length>0) { 
                      scope.removeTitleShow = true; 
                      debounce(function(){
                        if(!isNaN(scope.searchTitle)) {
                          if(scope.searchTitle.length>=5) {
                            id = scope.searchTitle;
                            title = ''
                          } else {
                            title= scope.searchTitle;
                            id = null;
                          }
                        } else {
                          title= scope.searchTitle;
                          id = null;
                        }
                        getPosts()
                      },200)
                    } else {
                      title = '';
                      id = null;
                      scope.removeTitleShow = false;
                      getPosts()
                    }
                    scope.searchTag = tags.name;
                }
                function getPosts(loadMore) {
                    if(loadMore != 'loadMore') {
                        from = 0;
                    }
                    scope.loadMoreShow = false;
                    $rootScope.hasLoaded = false;
                    getDataService.get({
                        param1:'posts',
                        param2:'search',
                        title:title|| undefined,
                        category:category || undefined,
                        tags:tags.id || undefined,
                        id:id || undefined,
                        from: from,
                        size:size
                    }).$promise.then(function(data){
                        scope.emptyTable = false;
                        $rootScope.hasLoaded = true;
                        if(scope.sortableDataName =='focusData' || scope.sortableDataName == 'prFocusNews') {
                            for(var i =0; i<data.recommended.length;i++) {
                                data.recommended[i].document_id = data.recommended[i].id;
                                data.recommended[i].type ='post'
                                if(!data.recommended[i].images || !data.recommended[i].images['140x105']) {
                                    data.recommended[i].images = {'140x105':'https://xdn.tf.rs/default/default-140x105.jpg'}
                                }
                            }
                        }
                        if(!data || !data.recommended) return;
                        if(loadMore=='loadMore') {
                            scope.allPosts = scope.allPosts.concat(data.recommended);
                        } else {
                            scope.allPosts.length = 0;
                            scope.allPosts = data.recommended;
                        }
                        if(data.total && data.total >scope.allPosts.length) {
                            scope.loadMoreShow = true;
                        } else {
                            scope.loadMoreShow = false;
                        }
                        if(scope.allPosts.length==0) {
                            scope.emptyTable = true;
                        }
                    }, function(error){
                        if(!window.navigator.onLine) {
                            offlineError()
                            $rootScope.hasLoaded = true;
                            return
                        }  
                        if(error.status ==401) {
                            var promise = refreshtokenService.getAccessToken();
                            promise.then(
                            function(answer) {
                                if(answer==200) {
                                    getPosts();
                                }
                                // do something
                            },
                            function(error) {
                            },
                            function(progress) {
                                // report progress
                            });
                        } else if(error.status ==502) {
                            serverError()
                        } else if(error.status ==404) {
                            scope.emptyTable = true;
                        } else {
                            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
                        }	   
                        $rootScope.hasLoaded = true;
                            
                    });
                }
                var sortableGrid = jQuery('.search-all-post-sortable-wrapper .sortable-grid');
                var sortableGridPrFocus = jQuery('pr-focus-news-modal .search-all-post-sortable-wrapper .sortable-grid')
                var statusFilter = jQuery('.search-all-post-sortable-wrapper .status-filter');
                var eklinkaBlock = jQuery('.pr-focus-news-modal .eklinika-block');
                function calculateHeightScrollableEl() {
                    if(scope.sortableDataName =='focusData') {
                        if(window.innerWidth >800) {
                            sortableGrid.height(window.innerHeight - 75 - statusFilter.height())
                        } else {
                            sortableGrid.height('auto')
                        }
                    } else if(scope.sortableDataName == 'recommendedNews') {
                        if(window.innerWidth >600) {
                            sortableGrid.height(jQuery('.recommended-news-modal .modal--media-content .left-column').height() - 20 - statusFilter.height())
                        } else {
                            sortableGrid.height('auto')
                        }
                    } else if (scope.sortableDataName == 'prFocusNews') {
                        if(window.innerWidth >600) {
                            sortableGridPrFocus.height(jQuery('.pr-focus-news-modal .modal--media-content .left-column').height() - 20 - statusFilter.height() - eklinkaBlock.height() - 25)
                        } else {
                            sortableGrid.height('auto')
                        }
                    }
                }
                $timeout(function() {
                    calculateHeightScrollableEl()
                },100)
                var onResize = function() {
                    if(scope.windowInnerWdth!=window.innerWidth) {
                        scope.$apply(function() {
                            calculateHeightScrollableEl()
                        })
                    }
				}
				angular.element($window).on('resize',onResize);
                scope.$on('$destroy',function() {
					angular.element($window).off('resize',onResize);
				})
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/searchAllPostSortable/searchAllPostSortableDirective.js
// module id = 446
// module chunks = 0